const qualsSagaNamespace = 'quals-saga';
export const GET_ALL_QUALS = `${qualsSagaNamespace}/GET_ALL_QUALS`;
export const CREATE_QUAL = `${qualsSagaNamespace}/CREATE_QUAL`;
export const GET_QUAL_REFERENCES = `${qualsSagaNamespace}/GET_QUAL_REFERENCES`;
export const LOAD_ALL_QUALS = `${qualsSagaNamespace}/LOAD_ALL_QUALS`;
